<template>
  <v-card class="pas-5 mt-8 ma-5 card-shadow" rounded="0">
    <v-data-table
      id="borderless-table"
      dense
      :headers="headersUserNotificationTable"
      :items="filteredSellData"
      :loading="loading"
      loading-text="Cargando información..."
      no-data-text="No se encontró información"
      :footer-props="{
        itemsPerPageText: 'Mostrar en grupo de',
        itemsPerPageAllText: 'Todos',
        pageText: '{0}-{1} de {2}',
      }"
      sort-by="published_at"
      :sort-desc="true"
    >
      <template #[`item.state`]="{ item }">
        <div>
          <template v-if="item.state === 1">
            <span
              class="mdi mdi-clock-alert-outline"
              style="color: #ffc107; font-size: 0.7cm"
            />
          </template>
          <template v-else-if="item.state === 2">
            <span
              class="mdi mdi-check-circle-outline"
              style="color: #218838; font-size: 0.7cm"
            />
          </template>
          <template v-else>
            <span
              class="mdi mdi-cancel"
              style="color: #c82333; font-size: 0.7cm"
            />
          </template>
        </div>
      </template>
      <template #[`item.actions`]="{ item }">
        <div class="row-containernewNotification">
          <v-btn icon title="Editar" @click="emitAction(item, 'edit')">
            <v-icon>mdi-file-edit-outline</v-icon>
          </v-btn>
          <v-btn icon title="Visualizar" @click="emitAction(item, 'view')">
            <v-icon>mdi-eye-outline</v-icon>
          </v-btn>
          <template v-if="item.state === 1 || item.state === 2">
            <v-btn
              icon
              title="Cancelar Publicación"
              @click="emitAction(item, 'notification')"
            >
              <v-icon :color="Number(item.state) === 2 ? 'red' : ''">
                mdi-bell-cancel-outline
              </v-icon>
            </v-btn>
          </template>
          <template v-else>
            <v-btn
              icon
              title="Volver a Publicar"
              @click="emitAction(item, 'notification')"
            >
              <v-icon>mdi-bell-check-outline</v-icon>
            </v-btn>
          </template>
          <v-btn icon title="Eliminar" @click="emitAction(item, 'delete')">
            <v-icon>mdi-delete-outline</v-icon>
          </v-btn>
        </div>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
  import { mapActions, mapGetters, mapState, mapMutations } from 'vuex';
  import axios from '@/plugins/axios';

  const headersUserNotificationTable = [
    { text: 'ID de publicación', value: 'id' },
    { text: 'Id_usuario', value: 'user_id' },
    { text: 'Versión', value: 'version' },
    { text: 'Canal', value: 'channel' },
    { text: 'Rol', value: 'role' },
    { text: 'Hora y Fecha', value: 'published_at' },
    { text: 'Estatus', value: 'state' },
    { text: 'Acciones', value: 'actions' },
  ];

  export default {
    name: 'NotificationsTable',
    props: {
      filteredSellData: {
        type: Array,
        required: true,
      },
      loading: {
        type: Boolean,
        required: true,
      },
    },
    data() {
      return {
        headersUserNotificationTable,
        loadingNotificationId: null,
      };
    },
    computed: {
      ...mapState('userNotification', ['yearlyNotifications']),
      ...mapGetters('userNotification', ['selectedNotificationDetails']),
    },
    mounted() {
      this.loadNotificationPreviewStep();
    },
    methods: {
      ...mapActions('userNotification', [
        'checkUserNotification',
        'selectNotification',
      ]),
      ...mapActions('modalStepsAfterLogin', [
        'updateModalState',
        'findStepByKey',
        'changeCurrentStepValue',
        'updateStepStatus',
        'loadNotificationPreviewStep',
      ]),
      ...mapMutations('userNotification', ['SET_YEARLY_NOTIFICATIONS']),

      async emitAction(item, actionType) {
        if (actionType === 'cancel') {
          try {
            const response = await axios.put(
              `/createnotification/${item.id}/cancel`
            );
            if (response.status === 200) {
              item.state = 3;
            }
          } catch (error) {
            this.$toast.error('Error al cancelar la publicación');
          }
        } else if (actionType === 'view') {
          await this.openNotification(item);
        } else {
          this.$emit('onActionClick', { item, actionType });
        }
      },

      async openNotification(notification) {
        if (this.loadingNotificationId === notification.id) return;
        this.loadingNotificationId = notification.id;

        const currentYearlyNotifications = this.yearlyNotifications;

        const exists = currentYearlyNotifications.find(
          (n) => n.id === notification.id
        );
        if (!exists) {
          this.SET_YEARLY_NOTIFICATIONS([
            ...currentYearlyNotifications,
            notification,
          ]);
        }

        await this.$nextTick();
        await this.selectNotification(notification.id);
        await this.$nextTick();

        const selectedNotification = this.selectedNotificationDetails;

        if (!selectedNotification) {
          this.$toast.error('No se pudo seleccionar la notificación');
          this.loadingNotificationId = null;
          return;
        }

        this.loadNotificationPreviewStep();
        await this.$nextTick();

        const openPreviewStep = await this.findStepByKey('notificationPreview');
        if (openPreviewStep) {
          openPreviewStep.visited = true;
          await this.updateStepStatus(openPreviewStep);
          await this.changeCurrentStepValue(openPreviewStep.value);
          await this.updateModalState(true);
          await this.checkUserNotification();
        } else {
          this.$toast.error(
            'No se pudo cargar el contenido de la notificación'
          );
        }

        this.loadingNotificationId = null;
      },
    },
  };
</script>

<style scoped>
  .table-row {
    height: 60px;
    background-color: rgb(240, 240, 240);
  }
  .v-data-table >>> .v-data-table-header {
    box-shadow: inset 0px 3px 6px #00000029, 0px 3px 6px #00000029 !important;
    height: 60px;
    border-bottom: 2px solid black;
    background-color: rgb(240, 240, 240);
  }
  #borderless-table >>> div > table > tbody > tr > td {
    border-bottom: 0px;
  }
  .row-containernewNotification {
    display: flex;
    align-items: center;
  }
  .disabled-button {
    color: #bdbdbd !important;
    pointer-events: none;
  }
</style>
